import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['search-input.component.scss'],
})
export class SearchInputComponent implements OnInit {
  @Input() searchFilter: string;
  @Input() placeholder = 'Pesquisar';
  @Output() searchFilterChange = new EventEmitter<string>();
  @Output() search?: EventEmitter<any> = new EventEmitter<any>();
  @Output() keyupSearch = new EventEmitter<string>();

  @Input() searchOptions = [];

  selectedOption;

  constructor() {}

  ngOnInit() {
    if (this.searchOptions.length > 0) {
      this.selectedOption = this.searchOptions[0].value;
    }
  }

  onChange() {
    this.searchFilterChange.emit(this.searchFilter);
  }

  onKeyup($event: any) {
    this.keyupSearch.emit(this.searchFilter);
  }

  onSubmit() {
    this.search.emit([this.searchFilter, this.selectedOption]);
  }
}
